/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_No_DataInputs */

const vi_customer_no_data = /** @type {(inputs: Customer_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có khách hàng nào`)
};

/**

* @param {Customer_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_no_data = /** @type {((inputs?: Customer_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_no_data(inputs)
});